import React, { useState, useRef, useEffect } from 'react'
import "../Styles/Homepage.css"
import { Tab, Tabs, TabContent, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from "swiper/react";
import {
  FreeMode,
  Navigation,
  Thumbs,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import axios from "axios"
import { API_ROOT, webPath } from "../apiConfig";
import { Helmet } from "react-helmet"
import LazyLoad from 'react-lazyload';
import AdCarousel from '../ReusableComp/Carasoul';
import '../Styles/Spinner.css';
import bannerImg from '../Images/adspacebanner.jpg'


const Homepage = ({ src, alt }) => {


  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  // const [data, setData] = useState(null);
  const [latestData, setLatestData] = useState(null);
  const [popularData, setPopularData] = useState(null);
  const [interviewData, setInterviewData] = useState(null);
  const [articleData, setArticleData] = useState(null);
  const [quickByteData, setQuickByteData] = useState(null);
  const [podcastData, setPodcastData] = useState(null);
  const [homeLatestNews, setHomeLatestNews] = useState(null);

  const [loading, setLoading] = useState(true);
  // const limit = 4;

  // console.log("quickByteData :", quickByteData);
  // console.log("popularData :", popularData);
  // console.log("articleData :", articleData);
  // console.log("homeLatestNews :", homeLatestNews);
  // console.log("podcastData :", podcastData);
  useEffect(() => {
    const removeHtmlTags = (html) => {
      return html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&ndash;/g, '—')
        .replace(/&rsquo;/g, "'");
    };


    console.log("popularData :", popularData)
    const fetchData = async () => {
      try {
        // homeLatestNews
        const res7 = await axios.get(`${API_ROOT}/api/post/homeLatestNews`);
        setHomeLatestNews({
          ...res7.data,
          latestNews: res7.data?.latest?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });
        // homelatest
        const res1 = await axios.get(`${API_ROOT}/api/post/homelatest`);
        setLatestData({
          ...res1.data,
          latest: res1.data?.latest?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });
        // homeInterview
        const res4 = await axios.get(`${API_ROOT}/api/post/homeInterview`);
        setInterviewData({
          ...res4.data,
          interview: res4.data?.latest?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });
        // homeArticle
        const res6 = await axios.get(`${API_ROOT}/api/post/homeArticle`);
        setArticleData({
          ...res6.data,
          article: res6.data?.latest?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });
        // homepopular
        const res2 = await axios.get(`${API_ROOT}/api/post/homepopular`);

        setPopularData({
          ...res2.data,
          popular: res2.data?.popular?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });


        // homeQuickByte
        const res5 = await axios.get(`${API_ROOT}/api/post/homeQuickByte`);
        setQuickByteData({
          ...res5.data,
          quickbyte: res5.data?.latest?.map(post => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          })),
        });



        // homePodcast








      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  console.log("article data :", articleData);
  useEffect(async () => {
    const removeHtmlTags = (html) => {
      return html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&ndash;/g, '—')
        .replace(/&rsquo;/g, "'");
    };
    const res3 = await axios.get(`${API_ROOT}/api/post/homePodcast`);
    setPodcastData({
      ...res3.data,
      podcast: res3.data?.latest?.map(post => ({
        ...post,
        post_content: removeHtmlTags(post.post_content),
      })),
    });
  }, [])

  useEffect(async () => {
    const removeHtmlTags = (html) => {
      return html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&ndash;/g, '—')
        .replace(/&rsquo;/g, "'");
    };
    const res3 = await axios.get(`${API_ROOT}/api/post/homePodcast`);
    setPodcastData({
      ...res3.data,
      podcast: res3.data?.latest?.map(post => ({
        ...post,
        post_content: removeHtmlTags(post.post_content),
      })),
    });
  }, [])



  const [activeKey, setActiveKey] = useState('tab1');

  const handleTabSelect = (key) => {
    setActiveKey(key);
  };



  const [setThumbsSwiper] = useState(null);

  const navigationPrevRef = useRef();
  const navigationNextRef = useRef();


  const [advertisementData, setAdvertisementData] = useState([]);
  const [homeAdvertise, setHomeAdvertise] = useState([]);
  const [footerAd, setFooterAd] = useState([]);

  useEffect(() => {
    const fetchAdvertisementData = async () => {
      try {
        const response = await axios.get(`${API_ROOT}/api/advertisement/get_active`);
        setAdvertisementData(response.data);
        setHomeAdvertise(response.data.filter(item => item.banner_type === "Home-2"))
        setFooterAd(response.data.filter(item => item.banner_type === "Footer-3"))
        // console.log(response.data)
      } catch (error) {
        console.error('Error fetching advertisement data:', error);
      }
    };

    fetchAdvertisementData();
  }, []); // The empty dependency array ensures that this effect runs once when the component mounts




  const pageTitle = "EnterpriseTalk - News | Editorial insights | Enterprise Updates";

  const [classNameTab, setClassNameTab] = useState('');
  const [className, setClassName] = useState('');
  const [className1, setClassName1] = useState('');
  const [className2, setClassName2] = useState('');
  const [className3, setClassName3] = useState('');
  const [className4, setClassName4] = useState('');
  const [className5, setClassName5] = useState('');
  //Krishna
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (!advertisementData || advertisementData.length === 0) return;

    setCurrentIndex((prevIndex) =>
      prevIndex === homeAdvertise.length - 1 ? 0 : prevIndex + 1
    );
  }, [homeAdvertise]);

  const currentAd = homeAdvertise[currentIndex];

  console.log("homeAdvertise :", homeAdvertise)

  console.log("advertisementData :",advertisementData)
  //Krishna

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {

      const removeTimer = setTimeout(() => {
        setClassName('');
      }, 0);


      const setTimer = setTimeout(() => {
        setClassName('loaded');
        currentSection++;


        if (currentSection <= sections) {
          setSectionClassName();
        }
      }, currentSection * 40);


      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    setSectionClassName();
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName1('');
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName1('loaded1');
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {

          window.removeEventListener('scroll', handleScroll);
        }
      }, currentSection * 150);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {

      if (window.scrollY > 100) {
        setSectionClassName();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName2('');
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName2('loaded2');
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 190 is reached
          window.removeEventListener('scroll', handleScroll);
        }
      }, currentSection * 190);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 190) { // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName3('');
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName3('loaded3');
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 230 is reached
          window.removeEventListener('scroll', handleScroll);
        }
      }, currentSection * 230);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 230) { // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName4('');
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName4('loaded4');
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 290 is reached
          window.removeEventListener('scroll', handleScroll);
        }
      }, currentSection * 290);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 290) { // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName5('');
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName5('loaded5');
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 290 is reached
          window.removeEventListener('scroll', handleScroll);
        }
      }, currentSection * 290);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 290) { // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {

      const removeTimer = setTimeout(() => {
        setClassNameTab('');
      }, 0);


      const setTimer = setTimeout(() => {
        setClassNameTab('loaded');
        currentSection++;


        if (currentSection <= sections) {
          setSectionClassName();
        }
      }, currentSection * 80);


      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    setSectionClassName();
  }, []);




  return (


    <div style={{ overflow: "hidden" }}  >


      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content="A Peer Knowledge Resource Expert inputs on challenges, triumphs &amp; innovative solutions from corporate Movers &amp; Shakers in global Leadership." />
        <meta name="title" property="og:title" content={pageTitle} />
        <meta property="og:type" content="PostDetails" />
        <meta name="image" property="og:image" content="https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp" />
        <meta name="description" property="og:description" content="A Peer Knowledge Resource Expert inputs on challenges, triumphs &amp; innovative solutions from corporate Movers &amp; Shakers in global Leadership." />
        <meta property="og:url" content="https://enterprisetalk.com/" />
        <meta property="og:image:width" content="844" />
        <meta property="og:image:height" content="172" />
        <meta property="og:image:type" content="image/png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="https://twitter.com/Enterprise_Talk"></meta>
        <link rel="canonical" href="https://enterprisetalk.com/" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content="A Peer Knowledge Resource Expert inputs on challenges, triumphs &amp; innovative solutions from corporate Movers &amp; Shakers in global Leadership." />
        <meta name="twitter:image" content="https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp" />
      </Helmet>



      {/* <HomepageMainSection /> */}
      {/* {homeLatestNews?( */}


      <div>

        <div className='mt-3 spaceincontent'>
          <div className="container container-max" >
            {/* Krishna */}
   {/* <LazyLoad className={className5}> */}
          {/* <div className="container container-max ">
            <div className="row mt-5 spaceincontentbottm">
               <div className="col-md-12 mb-2">
                <div >
                  
                    <a href=' https://informatica.enterprisetalk.com/' target="_blank"> <img
                      style={{ width: "100%", height: "auto" }}
                      src='https://enterprisetalk.com//uploads/pixel_img/ad%20banner.jpg'
                      alt={footerAd[0]?.banner_name} aria-label={footerAd[0]?.banner_name}
                      loading="lazy" width="640" height="360" /> </a>
            
                </div>
              </div> 
            </div>
          </div> */}
        {/* </LazyLoad> */}
            {/* Krishna */}
            <div className="row ">
              <h1 className='fw-bold borderB py-1 h5'>Latest</h1>
              <div className="col-md-9 borderR">

                <div>
                  <div>

                    {homeLatestNews && homeLatestNews?.latestNews && homeLatestNews?.latestNews.length > 0 && (
                      <a href={`/${homeLatestNews?.latestNews[0].cat_slug}/${homeLatestNews?.latestNews[0].post_name}`} aria-label={`Read more about ${homeLatestNews?.latestNews[0].post_title}`}>
                        <div>

                          <img
                            src={`${webPath}${homeLatestNews.latestNews[0]?.banner_img}?width=700`}
                            className='homeImg responsive-img large-img' alt={homeLatestNews?.latestNews[0].post_title} aria-label={homeLatestNews.latestNews[0].post_title} width="640"
                            height="360" />



                          <div className='paddings'>
                            <h2 className='fw-bold h2 hoverHead mt-2 '>{homeLatestNews?.latestNews[0].post_title}</h2>
                            <p style={{ fontSize: '12px' }}>
                              By <span className='fw-bold'>{homeLatestNews?.latestNews[0].post_author}</span> | {new Date(homeLatestNews?.latestNews[0].post_date).toLocaleDateString(undefined, options)}
                            </p>
                            <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }} >
                              {homeLatestNews?.latestNews[0].post_content}
                            </p>
                          </div>
                          <p className='hr' />
                        </div>
                      </a>
                    )}
                  </div>

                  {homeLatestNews && <div className='mainSecondBox mt-3'>


                    <div className='secondBox hover01' >
                      <div>
                        <a href={`/${homeLatestNews?.latestNews[1].cat_slug}/${homeLatestNews?.latestNews[1].post_name}`} aria-label={`Read more about ${homeLatestNews?.latestNews[1].post_title}`}>
                          <figure className="">
                            <img src={`${webPath}${homeLatestNews?.latestNews[1]?.banner_img}?width=500`} className='responsive-img1 large-img1 zoom-in twoSmalBox' alt={homeLatestNews?.latestNews[1].post_title} aria-label={homeLatestNews?.latestNews[1].post_title} width="640" height="360" />
                          </figure>
                        </a>
                      </div>
                      <div>
                        <a href={`/${homeLatestNews?.latestNews[1].cat_slug}/${homeLatestNews?.latestNews[1].post_name}`} aria-label={`Read more about ${homeLatestNews?.latestNews[1].post_title}`}> <h2 className='fw-bold h5 mt-3 hoverHead line-clamp' title={homeLatestNews?.latestNews[1].post_title}>{homeLatestNews?.latestNews[1].post_title}</h2></a>
                        <p style={{ fontSize: "12px" }}>
                          By <span className='fw-bold'>{homeLatestNews?.latestNews[1].post_author}</span> | {new Date(homeLatestNews?.latestNews[1].post_date).toLocaleDateString(undefined, options)}
                        </p>
                        <p className='just-text line-clamp mt-1' style={{ fontSize: "15px" }}>{homeLatestNews?.latestNews[1].post_content}</p>
                      </div>
                    </div>


                    <div className='borderR'></div>


                    <div className='secondBox hover01'>
                      <div>
                        <a href={`/${homeLatestNews?.latestNews[2]?.cat_slug}/${homeLatestNews?.latestNews[2].post_name}`} aria-label={`Read more about ${homeLatestNews?.latestNews[2].post_title}`}> <figure className="">
                          <img src={`${webPath}${homeLatestNews?.latestNews[2]?.banner_img}?width=500`} className='responsive-img1 large-img1 zoom-in twoSmalBox' alt={homeLatestNews?.latestNews[2].post_title} aria-label={homeLatestNews?.latestNews[2].post_title} width="640" height="360" />
                        </figure>
                        </a>
                      </div>
                      <div className='padLR'>
                        <a href={`/${homeLatestNews?.latestNews[2]?.cat_slug}/${homeLatestNews?.latestNews[2]?.post_name}`} aria-label={`Read more about ${homeLatestNews?.latestNews[2].post_title}`}><h2 className='fw-bold h5 mt-3 hoverHead line-clamp' title={homeLatestNews?.latestNews[2].post_title}>{homeLatestNews?.latestNews[2].post_title}</h2></a>
                        <p style={{ fontSize: "12px" }}>
                          By <span className='fw-bold'>{homeLatestNews?.latestNews[2].post_author}</span> | {new Date(homeLatestNews?.latestNews[2].post_date).toLocaleDateString(undefined, options)}
                        </p>
                        <p className='just-text line-clamp mt-1' style={{ fontSize: "15px" }}>{homeLatestNews?.latestNews[2].post_content}</p>
                      </div>
                    </div>



                  </div>
                  }

                </div>




              </div>






              <div className="col-md-3 DesktopResponsive">
                <div>
                  <div style={{ minHeight: "700" }}>
                    {/* <LazyLoad className={classNameTab}> */}
                    <Tabs activeKey={activeKey} onSelect={handleTabSelect} id="tabs-example" className='tabBtn nav-link1' style={{ color: "black !important" }}>

                      <Tab eventKey="tab1" title="Latest" className='text-black'>
                        <TabContent className='marTop'>
                          <div>
                            {/* {loading ? (
                          <p></p>
                        ) : ( */}
                            <div>
                              {latestData?.latest?.map((post, index) => (
                                <div key={index}>
                                  <div className='paddings'>
                                    <a href={`/${post.cat_slug}/${post.post_name}`} aria-label={`Read more about ${post.post_title}`}><h3 className='fw-bold h5 hoverHead line-clamp3' title={post.post_title}>{post.post_title}</h3></a>
                                    <p style={{ fontSize: '12px' }}>
                                      By <span className='fw-bold'>{post.post_author}</span> | {new Date(post.post_date).toLocaleDateString(undefined, options)}
                                    </p>
                                    <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }}>
                                      {post.post_content}
                                    </p>
                                  </div>
                                  <p className='hr' />
                                </div>
                              ))}
                            </div>
                            {/* )} */}
                          </div>
                        </TabContent>
                      </Tab>


                      <Tab eventKey="tab2" title="Popular" className='text-black'>
                        <TabContent className='marTop'>
                          <div>
                            {/* {loading ? (
                          <p></p>
                        ) : ( */}
                            <div>
                              {popularData?.popular?.map((post, index) => (
                                <div key={index}>
                                  <div className='paddings'>
                                    <a href={`/${post.cat_slug}/${post.post_name}`} aria-label={`Read more about ${post.post_title}`}><h3 className='fw-bold h5 hoverHead line-clamp3' title={post.post_title}>{post.post_title}</h3></a>
                                    <p style={{ fontSize: '12px' }}>
                                      By <span className='fw-bold'>{post.post_author}</span> | {new Date(post.post_date).toLocaleDateString(undefined, options)}
                                    </p>
                                    <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }}>
                                      {post.post_content}
                                    </p>
                                  </div>
                                  <p className='hr' />
                                </div>
                              ))}
                            </div>
                            {/* )} */}
                          </div>
                        </TabContent>
                      </Tab>

                    </Tabs>
                    {/* </LazyLoad> */}
                  </div>




                  {/* <div className='marTop heightAuto' style={{ textAlign: "center", height: "400px" }}> */}

                  {/* {advertisementData && advertisementData.length > 0 && (
                  <a href={`${advertisementData[1].dest_url}`} aria-label="Visit advertisement page">
                    <img className='mt-5' style={{ height: "300px", width: "auto" }} src={`${webPath}${advertisementData[1].banner_img}?width=600`} alt={advertisementData[1].banner_name} aria-label={advertisementData[1].banner_name} loading="lazy" width="640" height="360" />
                  </a>
                )} */}
                  <AdCarousel ads={homeAdvertise} className={className} />

                  {/* </div> */}

                </div>
              </div>
              <div className="col-md-3 MobileResponsive">
                <div>
                  <div>
                    <LazyLoad className={className2}>
                      <Tabs activeKey={activeKey} onSelect={handleTabSelect} id="tabs-example" className='tabBtn nav-link1' style={{ color: "black !important" }}>

                        <Tab eventKey="tab1" title="Latest" className='text-black'>
                          <TabContent className='marTop'>
                            <div>
                              {/* {loading ? (
                            <p></p>
                          ) : ( */}
                              <div>
                                {latestData?.latest?.map((post, index) => (
                                  <div key={index}>
                                    <div className='paddings'>
                                      <a href={`/${post.cat_slug}/${post.post_name}`} aria-label={`Read more about ${post.post_title}`}><h3 className='fw-bold h5 hoverHead line-clamp3' title={post.post_title}>{post.post_title}</h3></a>
                                      <p style={{ fontSize: '12px' }}>
                                        By <span className='fw-bold'>{post.post_author}</span> | {new Date(post.post_date).toLocaleDateString(undefined, options)}
                                      </p>
                                      <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }}>
                                        {post.post_content}
                                      </p>
                                    </div>
                                    <p className='hr' />
                                  </div>
                                ))}
                              </div>
                              {/* )} */}
                            </div>
                          </TabContent>
                        </Tab>


                        <Tab eventKey="tab2" title="Popular" className='text-black'>
                          <TabContent className='marTop'>
                            <div>
                              {/* {loading ? (
                            <p></p>
                          ) : ( */}
                              <div>
                                {popularData?.popular?.map((post, index) => (
                                  <div key={index}>
                                    <div className='paddings'>
                                      <a href={`/${post.cat_slug}/${post.post_name}`} aria-label={`Read more about ${post.post_title}`}><h3 className='fw-bold h5 hoverHead line-clamp3' title={post.post_title}>{post.post_title}</h3></a>
                                      <p style={{ fontSize: '12px' }}>
                                        By <span className='fw-bold'>{post.post_author}</span> | {new Date(post.post_date).toLocaleDateString(undefined, options)}
                                      </p>
                                      <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }}>
                                        {post.post_content}
                                      </p>
                                    </div>
                                    <p className='hr' />
                                  </div>
                                ))}
                              </div>
                              {/* )} */}
                            </div>
                          </TabContent>
                        </Tab>

                      </Tabs>
                    </LazyLoad>
                  </div>
                  <LazyLoad className={className1}>
                    <div className='marTop heightAuto' style={{ textAlign: "center", height: "400px" }}>
                      {advertisementData && advertisementData.length > 0 && (
                        <a href={`${advertisementData[1]?.dest_url}`} aria-label="Visit advertisement page">
                          <img className='mt-5' style={{ height: "300px", width: "auto" }} src={`${webPath}${advertisementData[1]?.banner_img}?width=600`} alt={advertisementData[1]?.banner_name} aria-label={advertisementData[1]?.banner_name} loading="lazy" width="640" height="360" />
                        </a>
                      )}


                    </div>
                  </LazyLoad>



                </div>
              </div>




            </div>

              <LazyLoad className={className4}> 
        <div className='container container-max'>

          <div className='row mt-5 spaceincontent justify-content-between align-items-center'>
            <h5 className='fw-bold borderB py-1 h4'>Podcasts</h5>

            {/* {loading ? (
            <p></p>
          ) : ( */}
            <div className="col-md-7 col-12 m-auto ">
              <div className='podText'>
                <a href={`/${podcastData?.podcast[0]?.cat_slug}/${podcastData?.podcast[0]?.post_name}`}><h6 className='fw-bold hoverHead guestFont2 line-clamp3' style={{ fontSize: "30px" }} title={podcastData?.podcast[0]?.post_title}>{podcastData?.podcast[0]?.post_title} </h6>
                  <p style={{ fontSize: "18px" }} className='fw-bold mt-2'>In conversation with</p>
                  <p className='guestPtag'>
                    By <span className='fw-bold'>{podcastData?.podcast[0]?.post_author}</span> | {new Date(podcastData?.podcast[0]?.post_date).toLocaleDateString(undefined, options)}
                  </p>
                  <button className='btn-pod'>Watch Now</button>

                  <div id="hotseat"></div>
                </a>

              </div>
            </div>
            {/* )} */}

            {/* {loading ? (
            <p></p>
          ) : ( */}
            <div className="col-md-5 col-12 m-auto mt-3 ">
              <a href={`/${podcastData?.podcast[0]?.cat_slug}/${podcastData?.podcast[0]?.post_name}`}> <img className='ImgBoxGuets2' src={`${webPath}${podcastData?.podcast[0]?.banner_img}?width=500`} alt={podcastData?.podcast[0]?.post_title} aria-label={podcastData?.podcast[0]?.post_title} loading="lazy" width="640" height="360" /></a>
              {/* <a href={`/${podcastData?.podcast[0]?.cat_slug}/${podcastData?.podcast[0]?.post_name}`}> <img className='ImgBoxGuets3' src="https://talkcmo.com/uploads/2025/07/1753443674985-GenAI%20as%20an%20Effective%20Business%20Tool.webp?width=500" alt={podcastData?.podcast[0]?.post_title} aria-label={podcastData?.podcast[0]?.post_title} loading="lazy" width="640" height="360" /></a> */}

            </div>
            {/* )} */}

          </div>

        </div>
        </LazyLoad> 
          </div>





        </div>



        <LazyLoad className={className1}>
          <h3 className='fw-bold  py-1 h4 container mt-5 container-max borderB' style={{ marginBottom: "-40px", textAlign: "center" }}>Guest Author</h3>
          <div className="container-fluid" style={{ padding: "0px" }}>
            <div className="row mt-5">
              <div className="col-md-12" >


                <div className='swiperBox'>

                  <Swiper
                    onSwiper={setThumbsSwiper}
                    loop={true}
                    spaceBetween={10}
                    slidesPerView={1}
                    freeMode={true}

                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs, Autoplay]}

                    autoplay={{
                      delay: 2000,
                      disableOnInteraction: false,
                    }}
                    navigation={{
                      prevEl: navigationPrevRef.current,
                      nextEl: navigationNextRef.current,
                    }}
                    breakpoints={{
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                      },
                      1199: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                      },
                    }}
                  >

                    <div>
                      {/* {loading ? (
                    <p></p>
                  ) : ( */}
                      <Swiper spaceBetween={50} slidesPerView={3}>

                        {interviewData?.interview?.map((interview, index) => (
                          <SwiperSlide key={index} style={{}}>
                            <a href={`/${interview?.cat_slug}/${interview?.post_name}`} > <Card style={{}}>
                              <Card.Img className="responsive-images"
                                src={`${webPath}${interview?.banner_img}?width=500`} alt={interview?.post_title} aria-label={interview?.post_title} width="100" height="550" />
                              <Card className='p-md-3 px-2 mb-2' style={{ height: "157px" }} >
                                <Card.Title className='fw-bold line-clamp hoverHead'>{interview?.post_title}</Card.Title>
                                <Card.Title>{interview?.post_author}</Card.Title>

                                <Card.Text className='mt-1 just-text line-clamp'>{interview?.post_content}</Card.Text>
                              </Card>
                            </Card>
                            </a>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                      {/* )} */}
                    </div>


                    <button className='btn-nav' style={{ cursor: "context-menu" }} ref={navigationPrevRef}>Previous</button>
                    <button className='btn-nav' style={{ cursor: "context-menu" }} ref={navigationNextRef}>Next</button>
                  </Swiper>

                </div>
              </div>

            </div>
          </div>
        </LazyLoad>



        {/* <LazyLoad className={className2}>
    <div className='container container-max'>
      <div className='row mt-5 spaceincontent'>


        <h3 className='fw-bold borderB py-1 h4'>Quick Bytes</h3>
        <div className='col-md-4 '>
          {loading ? (
            <p></p>
          ) : (
            <>
            
              {quickByteData?.quickbyte?.slice(2, 6).map((quickbyte, index) => (
                <div key={index} className='mt-3'>
                  <div className=''>
                    <a href={`/${quickbyte?.cat_slug}/${quickbyte?.post_name}`}><h3 className='fw-bold h5 hoverHead line-clamp' title={quickbyte?.post_title}>{quickbyte?.post_title}</h3></a>
                    <p style={{ fontSize: '12px' }} className='mt-1'>
                      By <span className='fw-bold'>{quickbyte?.post_author}</span> | {new Date(quickbyte?.post_date).toLocaleDateString(undefined, options)}
                    </p>
                  </div>
                  <p className='hr' />
                </div>
              ))}
            </>
          )}
        </div>

        {loading ? (
          <p></p>

        ) : (
          <div className='col-md-4 mt-3 borderR borderL '>
            <a href={`/${quickByteData?.quickbyte[0]?.cat_slug}/${quickByteData?.quickbyte[0]?.post_name}`}> <div className='hover01' >
              <div>
                <figure>
                  <img className='' style={{ width: "100%", borderRadius: "20px", height: "auto", objectFit: "cover" }} src={`${webPath}${quickByteData?.quickbyte[0]?.banner_img}?width=500`} alt={quickByteData?.quickbyte[0]?.post_title} aria-label={quickByteData?.quickbyte[0]?.post_title} loading="lazy" width="100" height="100" />
                </figure>
              </div>
              <div className='padLR'>
                <h4 className='fw-bold h5 mt-3 hoverHead line-clamp' title={quickByteData?.quickbyte[0]?.post_title}>{quickByteData?.quickbyte[0]?.post_title}</h4>
                <p style={{ fontSize: "12px" }}>
                  By <span className='fw-bold'>{quickByteData?.quickbyte[0]?.post_author}</span> |  {new Date(quickByteData?.latestNews[0]?.post_date).toLocaleDateString(undefined, options)}
                </p>
                <p className='just-text line-clamp mt-1' style={{ fontSize: "15px" }}>{quickByteData?.quickbyte[0]?.post_content}</p>
              </div>

            </div>
            </a>

          </div>
        )}

        {loading ? (
          <p></p>

        ) : (
          <div className='col-md-4 mt-3'>
            <a href={`/${quickByteData?.quickbyte[1]?.cat_slug}/${quickByteData?.quickbyte[1]?.post_name}`}><div className='hover01' >
              <div>
                <figure>
                  <img style={{ width: "100%", borderRadius: "20px", height: "auto", objectFit: "cover" }} src={`${webPath}${quickByteData?.quickbyte[1]?.banner_img}?width=500`} alt={quickByteData?.quickbyte[1]?.post_title} aria-label={quickByteData?.quickbyte[1]?.post_title} loading="lazy" width="100" height="100" />
                </figure>
              </div>
              <div className='padLR'>
                <h4 className='fw-bold h5 mt-3 hoverHead line-clamp' title={quickByteData?.quickbyte[1]?.post_title}>{quickByteData?.quickbyte[1]?.post_title}</h4>
                <p style={{ fontSize: "12px" }}>
                  By <span className='fw-bold'>{quickByteData?.quickbyte[1]?.post_author}</span> | {new Date(quickByteData?.latestNews[1]?.post_date).toLocaleDateString(undefined, options)}
                </p>
                <p className='just-text line-clamp mt-1' style={{ fontSize: "15px" }}>{quickByteData?.quickbyte[1]?.post_content}</p>
              </div>
            </div>
            </a>
          </div>
        )}


      </div>

    </div>
  </LazyLoad> */}



        <LazyLoad className={className3}>
          <div className='container container-max'>
            <div className='row mt-5 spaceincontent'>


              <h4 className='fw-bold borderB py-1 h4'>Articles</h4>




              {/* {loading ? (
            <p></p>
          ) : ( */}
              <div className='col-md-4 mt-3'>
                <a href={`/${articleData?.article[0]?.cat_slug}/${articleData?.article[0]?.post_name}`}> <div className='hover01'>
                  <div>
                    <figure>
                      <img
                      className='responsive-img1 large-img1'
                        // style={{ width: '100%', borderRadius: '20px', height: 'auto', objectFit: 'cover' }}
                        src={`${webPath}${articleData?.article[0]?.banner_img}?width=500`} // Assuming your API response has an 'imageSrc' property
                        alt={articleData?.article[0]?.post_title} aria-label={articleData?.article[0]?.post_title}
                        loading="lazy" width="100" height="100" /> </figure>
                  </div>
                  <div>
                    <h4 className='fw-bold h5 mt-3 hoverHead' title={articleData?.article[0]?.post_title}>{articleData?.article[0]?.post_title}</h4>
                    <p style={{ fontSize: '12px' }}>
                      By <span className='fw-bold'>{articleData?.article[0]?.post_author}</span> |  {new Date(articleData?.article[0]?.post_date).toLocaleDateString(undefined, options)}
                    </p>
                    <p className='just-text line-clamp mt-1' style={{ fontSize: '15px' }}>
                      {articleData?.article[0]?.post_content}
                    </p>
                  </div>
                </div>
                </a>
              </div>
              {/* )} */}



              {/* {loading ? (
            <p></p>
          ) : ( */}
              <div className='col-md-4 mt-3 borderR borderL' >
                <a href={`/${articleData?.article[1].cat_slug}/${articleData?.article[1].post_name}`}> <div className='hover01' >
                  <div>
                    <figure>
                      <img 
                       className='responsive-img1 large-img1'
                      // style={{ width: "100%", borderRadius: "20px", height: "auto", objectFit: "cover" }} 
                      src={`${webPath}${articleData?.article[1]?.banner_img}?width=500`} alt={articleData?.article[1].post_title} aria-label={articleData?.article[1].post_title} loading="lazy" width="100" height="100" />
                    </figure>
                  </div>
                  <div className='padLR'>
                    <h4 className='fw-bold h5 mt-3 hoverHead' title={articleData?.article[1].post_title}>{articleData?.article[1]?.post_title}</h4>
                    <p style={{ fontSize: "12px" }}>
                      By <span className='fw-bold'>{articleData?.article[1]?.post_author}</span> | {new Date(articleData?.article[1]?.post_date).toLocaleDateString(undefined, options)}
                    </p>
                    <p className='just-text line-clamp mt-1' style={{ fontSize: "15px" }}> {articleData?.article[1]?.post_content}</p>
                  </div>
                </div>
                </a>
              </div>
              {/* )} */}


              <div className='col-md-4 '>


                {/* {loading ? (
              <p></p>
            ) : ( */}
                <>

                  {articleData?.article?.slice(2, 6)?.map((article, index) => (
                    <div key={index} className='mt-3'>
                      <div className=''>
                        <a href={`/${article?.cat_slug}/${article?.post_name}`}> <h5 className='fw-bold h5 hoverHead line-clamp' title={article?.post_title}>{article?.post_title}</h5></a>
                        <p style={{ fontSize: '12px' }} className='mt-1'>
                          By <span className='fw-bold'>{article?.post_author}</span> | {new Date(article?.post_date).toLocaleDateString(undefined, options)}
                        </p>
                      </div>
                      <p className='hr' />
                    </div>
                  ))}
                </>
                {/* )} */}

              </div>

            </div>

          </div>
        </LazyLoad>



       



        <LazyLoad className={className5}>
          <div className="container container-max ">
            <div className="row mt-5 spaceincontentbottm">
              {/* <div className="col-md-12 mb-2 borderB">
                <div >
                  {footerAd && footerAd.length > 0 && (
                    <a href={`${footerAd[0]?.dest_url}`} target="_blank"> <img
                      style={{ width: "100%", height: "auto" }}
                      src={`${webPath}${footerAd[0]?.banner_img}`}
                      alt={footerAd[0]?.banner_name} aria-label={footerAd[0]?.banner_name}
                      loading="lazy" width="640" height="360" /> </a>
                  )}
                </div>
              </div> */}
              <AdCarousel ads={footerAd} className={className1}/>
            </div>
          </div>
        </LazyLoad>


      </div>
      {/* ):( <div class="loader"></div>)} */}


    </div>

  )
}



export default Homepage